// @flow
import React, { memo } from 'react';
import IconWrapper from './IconWrapper';
import LoadingIcon from './LoadingIcon';

export default memo<{}>(() => (
  <IconWrapper><LoadingIcon /></IconWrapper>
));
